import { Typography, Stack, Box, Button, Divider, Grid, Select, InputLabel, IconButton, TextField, MenuItem } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ReactComponent as EditIcon } from "../../../Icons/EditIcon.svg"
import { ReactComponent as AddContactIcon } from "../../../Icons/AddContactIcon.svg"
import { useForm, Controller } from 'react-hook-form'
import ClearIcon from '@mui/icons-material/Clear';
import axios from 'axios'
import axiosInstance from '../../../api/axiosInstance'
import { useDispatch, useSelector } from 'react-redux'
import { removeData } from '../../../Redux/Feature/AdminSlice'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import PhoneInputController from '../../../CommonComponents/PhoneInputController'
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import FormatNumber from '../../../CommonComponents/FormatNumber'


export default function Details() {

    const [block, setBlock] = useState(1)
    const { formState: { errors }, handleSubmit, control, setValue } = useForm({
        mode: "onTouched"
    })

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [userData, setUserData] = useState({})
    const user = useSelector((state) => state.AdminData.admin);

    console.log(user)

    const initialEmergencycontact = { name: "", contact_no: "" }
    const [EmergencyContact, setEmergencyContact] = useState([initialEmergencycontact])
    const [Details, setDetails] = useState({ name: "", nationality: "", contact_no: "", email: "" })

    
    const fetchUser = async () => {
      try {
        const response = await axiosInstance.get(`/get-paiduser-by-id/${user.id}`)
        console.log(response)
        setUserData(response?.data?.data)
      } catch (error) {
        console.log(error)
        if(error.response.status === 401){
          navigate('/login')
          dispatch(removeData())
      }
      }
    }

    useEffect(() => {
      if(user.id){
        fetchUser()
      }
    }, [user.id])


    useEffect(() => {
      if(userData){
        setValue("name", userData?.userData?.name)
        setValue("phone", userData?.userData?.phone)
        setValue("grade", userData?.userData?.grade)
        setValue("schoolAttended", userData?.userData?.schoolAttended)
        const parsedDate = dayjs(userData?.userData?.yearOfStudy);
        setValue("yearOfStudy", parsedDate.isValid() ? parsedDate : null);
      }   
    }, [userData])


    const handleDeleteContact = (ind) => {
        const data = EmergencyContact.filter((itm, index) => (ind !== index))
        setEmergencyContact(data)
    }

    const onSubmit = async (data) => {
      const { name, phone, grade, yearOfStudy, schoolAttended } = data

      // setDetails({ name: name, nationality: nationality, contact_no: contact_no, email: email })

      // setEmergencyContact((prev) => {
      //     const dataas = EmergencyContact.map((itm, index) => ({
      //         Emergency_name: data[`Emergency_name${index + 1}`],
      //         Emergency_contact: data[`Emergency_contact${index + 1}`],
      //     }))
      //     return dataas
      // })

      try {
        const response = await axiosInstance.post(`update-user-data/${user.id}`, {name, phone, grade, yearOfStudy, schoolAttended})

        if(response.status === 200){
          fetchUser()
          setBlock(1)
        }
      } catch (error) {
        console.log(error)
      }


  }

    

    const EditBlock = () => {
        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container justifyContent={{ md: "start", xs: "center" }} columnGap={15}>
                    <Grid xs={12} md={4.5}>
                    <InputLabel
                sx={{
                  mt : 2,
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                Full name<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <Controller
                name={`name`}
                rules={{
                    required: "Name is required",
                    maxLength: {
                      value: 70,
                      message: "Name cannot exceed 70 Characters",
                    },
                    minLength : {
                      value: 3,
                      message: "Name cannot below 3 Characters",
                    }
                  }}
                control={control}
                // label={`Title (${lang.label})`}
                render={({ field }) => (
                  <TextField
                    placeholder={`Enter Full name`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.name ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.name ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.name ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.name ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.name) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.name ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>{errors?.name?.message}</Typography> : null }

                        

              <InputLabel
                sx={{
                  mt : 2,
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                Phone<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <PhoneInputController
                name="phone"
                control={control}
                rules={{ required: 'Phone number is required' }}
              />
              {errors?.phone ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>{errors?.phone?.message}</Typography> : null }

              <InputLabel
                sx={{
                  mt : 2,
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                Grade<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <Controller
                name={`grade`}
                rules={{
                    required: "Grade is required",
                    maxLength: {
                      value: 70,
                      message: "Grade cannot exceed 70 Characters",
                    },
                    minLength : {
                      value: 1,
                      message: "Grade cannot below 1 Characters",
                    }
                  }}
                control={control}
                // label={`Title (${lang.label})`}
                render={({ field }) => (
                  <TextField
                    placeholder={`Enter grade`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.grade ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.grade ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.grade ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.grade ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.grade) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.grade ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>{errors?.grade?.message}</Typography> : null }  


              <InputLabel
                sx={{
                  mt : 2,
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                School Attended<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <Controller
                name={`schoolAttended`}
                rules={{
                    required: "School Attended is required",
                    maxLength: {
                      value: 70,
                      message: "School Attended cannot exceed 70 Characters",
                    },
                    minLength : {
                      value: 1,
                      message: "School Attended cannot below 1 Characters",
                    }
                  }}
                control={control}
                // label={`Title (${lang.label})`}
                render={({ field }) => (
                  <TextField
                    placeholder={`Enter School Attended`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.schoolAttended ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.schoolAttended ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.schoolAttended ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.schoolAttended ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.schoolAttended) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.schoolAttended ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>{errors?.schoolAttended?.message}</Typography> : null }   
                       
                       
              <InputLabel
                sx={{
                  mt : 2,
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "neutral 7",
                }}
              >
                Year of Study<span style={{color : 'red'}}>*</span>
              </InputLabel>
              <Controller
                      name="yearOfStudy"
                      control={control}
                    //   defaultValue={Details?.dob ? dayjs(Details?.dob) : null}
                      
                      rules={{ required: true }}
                      render={({ field }) => (
                        <LocalizationProvider style={{pt : 0}} dateAdapter={AdapterDayjs}>
                          <DemoContainer style={{pt : 0}} components={["DatePicker"]}>
                            <DatePicker
                                style={{pt : 0}}
                              {...field}
                              sx={{
                                width: "100%",
                                pt : '0px',
                                backgroundColor: "rgb(249, 250, 251)",
                                ".MuiSvgIcon-root": { fill: "#1A2461" },
                                "& .MuiInputBase-input": {
                                  color: errors?.yearOfStudy ? "red" : "black", // Text color based on error state
                                },
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    borderColor: errors?.yearOfStudy
                                      ? "red"
                                      : "rgba(0, 0, 0, 0.23)", // Default border color
                                  },
                                  "&:hover fieldset": {
                                    borderColor: errors?.yearOfStudy
                                      ? "red"
                                      : "rgba(0, 0, 0, 0.87)", // Hover border color
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: errors?.yearOfStudy
                                      ? "red"
                                      : "rgba(0, 0, 0, 0.87)", // Focused border color
                                  },
                                },
                              }}
                              format="DD/MM/YYYY"
                              fullWidth
                              maxDate={dayjs()}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      )}
                    />
                    {errors?.yearOfStudy && (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        Please select year of study
                      </Typography>
                    )}         
                        {/* <InputLabel sx={{ mt: 3, mb: 1,fontSize: "16px",
                        fontWeight: 600,
                        color: "black" }} >{errors?.nationality ? 'Nationality*' : 'Nationality'}</InputLabel>
                        <Controller
                            name="nationality"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => <Select 
                            {...field}
                            error={Boolean(errors.nationality) ? true : false} 
                            sx={{
                                width: "100%",
                                backgroundColor: "rgb(249, 250, 251)",
                                borderRadius: 0,
                                "& .MuiInputBase-input": {
                                  color: errors?.nationality ? "red" : "black",
                                },
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    borderColor: errors?.nationality
                                      ? "#ff5e74"
                                      : "rgba(0, 0, 0, 0.23)",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: errors?.nationality
                                      ? "#ff5e74"
                                      : "rgba(0, 0, 0, 0.23)",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: errors?.nationality
                                      ? "#ff5e74"
                                      : "rgba(0, 0, 0, 0.23)",
                                  },
                                },
                              }}
                            >
                                <MenuItem value={1}>Indian</MenuItem>
                            </Select>}
                        />
                        {errors?.nationality ? (
                                <Typography
                                  style={{ color: "#ff5e74", margin: "0.3rem" }}
                                >
                                  Please select nationality
                                </Typography>
                              ) : null} */}

                    </Grid>
                    {/* <Grid xs={12} md={4.5} mt={3} border=".5px solid #737373" sx={{ height: "fit-content", padding: "10px", borderRadius: "10px" }}>
                        {EmergencyContact?.map((item, index) => {
                            return (
                                <Box sx={{ mt: ((EmergencyContact.length) == (index + 1)) ? 5 : 0 }}>
                                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                                        <Typography variant="h7_1">Emergency Contact {index + 1}</Typography>
                                        {index > 0 && <IconButton onClick={() => handleDeleteContact(index)}> <ClearIcon sx={{ color: "#f37777", fontSize: "30px" }} /></IconButton>}
                                    </Stack>
                                    <InputLabel sx={{ mt: 3, mb: 1 }} >{Boolean(errors[`Emergency_name${index + 1}`]) ? "Name*" : "Name"}</InputLabel>
                                    <Controller
                                        name={`Emergency_name${index + 1}`}
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => <TextField
                                        placeholder = 'Enter Name'
                                        error={Boolean(errors[`Emergency_name${index + 1}`]) ? true : false} {...field} 
                                        sx={{
                                            width: "100%",
                                            backgroundColor: "rgb(249, 250, 251)",
                                            borderRadius: 0,
                                            "& .MuiInputBase-input": {
                                              color: Boolean(errors[`Emergency_name${index + 1}`]) ? "red" : "black",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                              "& fieldset": {
                                                borderColor: Boolean(errors[`Emergency_name${index + 1}`])
                                                  ? "#ff5e74"
                                                  : "rgba(0, 0, 0, 0.23)",
                                              },
                                              "&:hover fieldset": {
                                                borderColor: Boolean(errors[`Emergency_name${index + 1}`])
                                                  ? "#ff5e74"
                                                  : "rgba(0, 0, 0, 0.23)",
                                              },
                                              "&.Mui-focused fieldset": {
                                                borderColor: Boolean(errors[`Emergency_name${index + 1}`])
                                                  ? "#ff5e74"
                                                  : "rgba(0, 0, 0, 0.23)",
                                              },
                                            },
                                          }}
                                        />}
                                    />
                                    {Boolean(errors[`Emergency_name${index + 1}`]) ? <Typography
                                  style={{ color: "#ff5e74", margin: "0.3rem" }}
                                >
                                  Please select name
                                </Typography> : null}
                                    <InputLabel sx={{ mt: 3, mb: 1 }} >{Boolean(errors[`Emergency_contact${index + 1}`]) ? 'Contact Number*' : 'Contact Number'}</InputLabel>
                                    <Controller
                                        name={`Emergency_contact${index + 1}`}
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => <TextField 
                                        placeholder = 'Enter contact number'
                                        error={Boolean(errors[`Emergency_contact${index + 1}`]) ? true : false} {...field}
                                        sx={{
                                            width: "100%",
                                            backgroundColor: "rgb(249, 250, 251)",
                                            borderRadius: 0,
                                            "& .MuiInputBase-input": {
                                              color: Boolean(errors[`Emergency_contact${index + 1}`]) ? "red" : "black",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                              "& fieldset": {
                                                borderColor: Boolean(errors[`Emergency_contact${index + 1}`])
                                                  ? "#ff5e74"
                                                  : "rgba(0, 0, 0, 0.23)",
                                              },
                                              "&:hover fieldset": {
                                                borderColor: Boolean(errors[`Emergency_contact${index + 1}`])
                                                  ? "#ff5e74"
                                                  : "rgba(0, 0, 0, 0.23)",
                                              },
                                              "&.Mui-focused fieldset": {
                                                borderColor: Boolean(errors[`Emergency_contact${index + 1}`])
                                                  ? "#ff5e74"
                                                  : "rgba(0, 0, 0, 0.23)",
                                              },
                                            },
                                          }}
                                        />}
                                    />
                                    {Boolean(errors[`Emergency_contact${index + 1}`]) ? <Typography
                                  style={{ color: "#ff5e74", margin: "0.3rem" }}
                                >
                                  Please select contact number
                                </Typography> : null}
                                </Box>
                            )
                        })}
                        <Button onClick={() => setEmergencyContact((prev) => ([...prev, initialEmergencycontact]))} sx={{ mt: 3 }} startIcon={<AddContactIcon fill="#FFFFFF" />} variant="standard">Add Another Contact</Button>
                    </Grid> */}
                </Grid>
                <Stack mt={3} direction="row" alignItems="center" gap="30px">
                    <Button type="submit" variant="standard">Save</Button>
                    <Button onClick={() => { setBlock(1) }} variant="outlined">Cancel</Button>
                </Stack>
            </form>
        )
    }

    const ReviewBlock = () => (
        <Grid container columnGap={15}>
            <Grid>
                <InputLabel sx={{ mt: 3, mb: 1 }} >Name</InputLabel>
                <Typography variant='h7_1' color="#1A2461">{userData?.userData?.name}</Typography>
                <InputLabel sx={{ mt: 3, mb: 1 }} >Email</InputLabel>
                <Typography variant='h7_1' color="#1A2461">{userData?.email}</Typography>
                <InputLabel sx={{ mt: 3, mb: 1 }} >Contact Number</InputLabel>
                <Typography variant='h7_1' color="#1A2461">{<FormatNumber number={`+${userData?.userData?.phone}`} /> }</Typography>
                <InputLabel sx={{ mt: 3, mb: 1 }} >School Attended</InputLabel>
                <Typography variant='h7_1' color="#1A2461">{userData?.userData?.schoolAttended}</Typography>
                <InputLabel sx={{ mt: 3, mb: 1 }} >Grade</InputLabel>
                <Typography variant='h7_1' color="#1A2461">{userData?.userData?.grade}</Typography>
                <InputLabel sx={{ mt: 3, mb: 1 }} >Year of Study</InputLabel>
                <Typography variant='h7_1' color="#1A2461">{dayjs(userData?.userData?.yearOfStudy).format("DD/MM/YYYY")}</Typography>
            </Grid>
            {/* <Grid mt={3} xs={12} lg={4} border=".5px solid #737373" sx={{ height: "fit-content", padding: "10px", borderRadius: "10px" }}>
                <Typography variant="h7_1">Emergency Contact 1</Typography>
                <InputLabel sx={{ mt: 3, mb: 1 }} >Name</InputLabel>
                <Typography variant='h7_1' color="#1A2461">Johnathan Doe</Typography>
                <InputLabel sx={{ mt: 3, mb: 1 }} >Contact Number</InputLabel>
                <Typography variant='h7_1' color="#1A2461">+65 654 987 321</Typography>
            </Grid> */}
        </Grid>
    )




    return (
        <Box>
            <Stack mb={1} direction="row" alignItems="center" justifyContent={{xs :"space-between", sm : 'space-between', md : 'space-between', lg : 'start', xl : 'start'}} gap="100px">
                <Typography variant="h7_1">Personal details</Typography>
                <Button onClick={() => setBlock(2)} startIcon={<EditIcon fill="#FFFFFF" />} variant="contained">Edit</Button>
            </Stack>
            <Divider />
            {block == 1 && <ReviewBlock />}
            {block == 2 && <EditBlock />}
        </Box>
    )
}
